export interface AppUpdateState {
  available: boolean;
  currentAsset: string;
  nextAsset: string;
}

type Listener = (state: AppUpdateState) => void;
const listeners = new Set<Listener>();
let state: AppUpdateState = { available: false, currentAsset: "", nextAsset: "" };

function moduleAsset(documentValue: Document): string {
  return documentValue.querySelector<HTMLScriptElement>('script[type="module"][src]')?.getAttribute("src") ?? "";
}

export function readAppUpdateState() { return { ...state }; }
export function subscribeAppUpdate(listener: Listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function installAppVersionMonitor(intervalMs = 5 * 60_000): () => void {
  if (typeof window === "undefined") return () => undefined;
  const currentAsset = moduleAsset(document);
  let stopped = false;
  const check = async () => {
    try {
      const response = await fetch(`/?mh_version_check=${Date.now()}`, { cache: "no-store", signal: AbortSignal.timeout(15_000) });
      if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), "text/html");
      const nextAsset = moduleAsset(parsed);
      const available = Boolean(currentAsset && nextAsset && new URL(nextAsset, location.origin).pathname !== new URL(currentAsset, location.origin).pathname);
      if (available !== state.available || nextAsset !== state.nextAsset) {
        state = { available, currentAsset, nextAsset };
        listeners.forEach((listener) => listener(readAppUpdateState()));
      }
    } catch { /* Offline and transient deploy checks are intentionally fail-open. */ }
  };
  const timer = window.setInterval(() => { if (!stopped && document.visibilityState === "visible") void check(); }, intervalMs);
  void check();
  return () => { stopped = true; window.clearInterval(timer); };
}
